import { render, staticRenderFns } from "./EscalasFormComponent.vue?vue&type=template&id=dd258ede&"
import script from "./EscalasFormComponent.vue?vue&type=script&lang=js&"
export * from "./EscalasFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./EscalasFormComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports